import styled from 'styled-components';
import { colors } from '@badi/badi-components';

export const BlockWrapper = styled.div`
  border-bottom: 1px solid ${colors.lightGrey};
`;
